"use strict";

angular.module('PatientApp').service('PaymentGatewayService', function (VuexStore) {
  return {
    process: function process(payment) {
      return VuexStore.dispatch('processPayment', {
        payment: payment
      });
    },
    resume: function resume() {
      return VuexStore.dispatch('resumePayment');
    }
  };
});